"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";
import { CrowdRiffSection } from "@/types/dto/destinations-page/destination-page-types";

interface CrowdRiffSectionProps {
  crowdRiffSection: CrowdRiffSection;
  showCopyText?: boolean;
  moduleRankingPosition?: string;
}

const LazyLoadCrowdRiffGallerySection = ({
  crowdRiffSection,
  showCopyText = true,
  moduleRankingPosition
}: CrowdRiffSectionProps) => (
  <GenericLazyLoader
    importComponent={() =>
      import("@/components/common/crowdriff-gallery/crowd-riff-gallery-section")
    }
    componentProps={{ crowdRiffSection, showCopyText, moduleRankingPosition }}
    debugName="Crowdriff Gallery Section"
    threshold={0.1}
    rootMargin="200px 0px"
  />
);

export default LazyLoadCrowdRiffGallerySection;
